import React from 'react';
import { Link } from 'react-router-dom'
import { cookieUtil } from '@/assets/js/cookie'

export default class SideMenu extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }
  gotoDetail(e, item) {
    e.preventDefault()
    if (!item.ErMenu) {
      this.handleUrl(item)
    }
  }
  handleUrl(item) {
    cookieUtil.unset('indexCacheHeight')
    this.props.history.push(item.url)
    window.$('.rightside-menu').removeClass('active')
    window.$('body').removeClass('modal-open')
  }
  render() {
    let deepIndex = this.props.deepIndex || 0
    deepIndex++
    return (
      <React.Fragment>
        {
          this.props.menuList.map((item, index) =>
            <div className="channel-item" key={index}>
              {/* 判断有下一级还是跳转 */}
              <Link onClick={(e) => this.gotoDetail(e, item)} to={item.url} className={"channel-item-title deep-index-" + deepIndex}>
                <span>{item.name}</span>
                {item.ErMenu && <i className="base-arrow"></i>}
              </Link>
              {
                item.ErMenu && <div className="sub-channel-box">
                  {
                    <SideMenu menuList={item.ErMenu} deepIndex={deepIndex} history={this.props.history} />
                  }
                </div>
              }
            </div>
          )
        }
      </React.Fragment>
    );
  }
}
